module.exports = __webpack_public_path__ + "img/mega-drill.9adda21e.jpg";